var React = require("react");
var Truncate = require('react-text-truncate');
var StageFilters = require('../stage_filters');
var TruncateToggle = require('../../../components/truncate_toggle');
var { withNamespaces } = require('react-i18next');
var Icon = require('infl-icons').Icon;
var RegularHeader = require('../regular_header');

const Arrow = ({}) => <span className='experience-header__arrow'></span>;

const FilterRow = withNamespaces()(({ onTabChange, selectedTabIndex, challengeStages, t }) => (
  <div className={'experience-header__row experience-header__filters'}>
    <div className='filter-dropdown pt-override'>
      <StageFilters
        onFilterChange={onTabChange}
        selectedFilterIndex={selectedTabIndex}
        challengeStages={challengeStages}/>
    </div>
  </div>
));

const FilterRowUxDebt = withNamespaces()(({ onTabChange, selectedTabIndex, challengeStages, onFilterChange, challengeTypes, selectedChallengeFilter }) => (
  <div className={'experience-header__filters-uxdebt'}>
    <RegularHeader
      selectedTabIndex={selectedTabIndex}
      onTabChange={onTabChange}
      onFilterChange={onFilterChange}
      challengeTypes={challengeTypes}
      selectedChallengeFilter={selectedChallengeFilter}
      challengeStages={challengeStages} />
  </div>
));

const BackButton = withNamespaces('HubFE')(({ t }) => (
  <a className='experience-header__back-button' href='/challenges'>
      <Icon icon='arrow-left'/>
      <span className='experience-header__back-button-text scheme-color'>{t('Back to Challenges')}</span>
  </a>
));
const DetailRow = withNamespaces()(({ id, name, description, image, leaderboard_rank, t }) => (
  <div className='experience-header__row experience-header__details'>
    { image ? <HeaderImage image={image} /> : null }
    <div className='experience-header__details-text'>
      <h1 className='experience-header__details-header'>
        <Truncate
          line={2}
          text={name}
          truncateText="..." />
      </h1>
      <div className='experience-header__details-description'>
        <TruncateToggle
          text={description}
          moreText={t('see more...')}
          lessText={t('see less')}
          lines={3} />
          <div className='experience-header__ranking'>
            <span dangerouslySetInnerHTML={{__html: "Your Points Ranking: " + leaderboard_rank}} />
            <div className='leaderboard'>
              <a href={"/channels/" + id + "/leaderboard"}>View Leaderboard</a>
            </div>
          </div>
      </div>
    </div>
  </div>
));

const HeaderImage = ({ image }) => (
  <div className='experience-header__img'>
    <img src={image} />
  </div>
);

const HeaderLayout = ({ currentObject, ...actionProps }) => (
  <div>
    <FilterRow {...actionProps} />
    <DetailRow {...currentObject} />
  </div>
);

const HeaderLayoutUxDebt = ({ currentObject, ...actionProps }) => (
  <div>
    <DetailRow {...currentObject} />
    <FilterRowUxDebt {...actionProps} />
  </div>
);

const ExperienceHeader = ({ ...actionProps }) => (
  <div className='experience-header__container-uxdebt'>
    <div className='experience-header__back-button-container'><BackButton /></div>
    <HeaderLayoutUxDebt {...actionProps} />
  </div>
);

export default withNamespaces()(ExperienceHeader);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/experience_header/index.jsx